@if (initialized) {
    <div class="grid p-fluid">

        <div class="col-12">
            <mvs-widget
                    *ngIf="basicDataWidget"
                    [widgetData]="basicDataWidget"
            ></mvs-widget>
        </div>

    </div>
}